export const JIRA_HOSTS_TYPES = {
  CLOUD: 'cloud',
  SERVER: 'server'
};
